var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 11.9441C30.0424 12.6196 28.9821 13.1362 27.86 13.4741C27.2577 12.7816 26.4573 12.2908 25.567 12.0681C24.6767 11.8453 23.7395 11.9013 22.8821 12.2286C22.0247 12.5558 21.2884 13.1385 20.773 13.8979C20.2575 14.6572 19.9877 15.5565 20 16.4741V17.4741C18.2426 17.5197 16.5013 17.13 14.931 16.3396C13.3607 15.5492 12.0103 14.3828 11 12.9441C11 12.9441 7 21.9441 16 25.9441C13.9405 27.3421 11.4872 28.0431 9 27.9441C18 32.9441 29 27.9441 29 16.4441C28.9991 16.1656 28.9723 15.8877 28.92 15.6141C29.9406 14.6076 30.6608 13.3369 31 11.9441V11.9441Z",
    stroke: "#6C5CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.eb3f0c70fc0388dd7b6ce64c19606cad.svg";
export { ForwardRef as ReactComponent };